import { useState } from 'react';
import { Button, Icon, useToast } from '@chakra-ui/react';
import { FiMessageSquare } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import { useUser } from '../../contexts/UserContext';
import { getOrCreateConversation } from '../../hooks/useMessages';

export const NewMessageButton = ({ targetUid }) => {
  const { currentUser } = useAuth();
  const { userData } = useUser();
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  // Don't show if messaging yourself
  if (!currentUser || currentUser.uid === targetUid) return null;

  const handleClick = async () => {
    setLoading(true);
    try {
      // Fetch the target user's profile data from users collection
      const targetSnap = await getDoc(doc(db, 'users', targetUid));
      const targetData = targetSnap.exists() ? targetSnap.data() : {};

      const conversationId = await getOrCreateConversation(
        currentUser.uid,
        targetUid,
        {
          username: userData?.anonymizedUsername || 'User',
          avatarUrl: userData?.avatarUrl || '',
          isFullyAnonymous: userData?.isFullyAnonymous || false,
        },
        {
          username: targetData.isFullyAnonymous ? 'Anonymous' : (targetData.anonymizedUsername || 'User'),
          avatarUrl: targetData.isFullyAnonymous ? '' : (targetData.avatarUrl || ''),
          isFullyAnonymous: targetData.isFullyAnonymous || false,
        }
      );
      navigate(`/messages/${conversationId}`);
    } catch (err) {
      console.error('Error starting conversation:', err);
      toast({
        title: 'Error starting conversation',
        description: err.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handleClick}
      isLoading={loading}
      loadingText="Opening..."
      leftIcon={<Icon as={FiMessageSquare} />}
      colorScheme="orange"
      variant="outline"
      size="sm"
    >
      Message
    </Button>
  );
};
